// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__6LOe0","rotation":"spinner_rotation__C8DQB","spinnerHarness":"spinner_spinnerHarness__SI5nY"};